import { render, staticRenderFns } from "./GraphPanel.vue?vue&type=template&id=24e01927&scoped=true&lang=html&"
import script from "./GraphPanel.vue?vue&type=script&lang=js&"
export * from "./GraphPanel.vue?vue&type=script&lang=js&"
import style0 from "./GraphPanel.vue?vue&type=style&index=0&id=24e01927&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e01927",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e01927')) {
      api.createRecord('24e01927', component.options)
    } else {
      api.reload('24e01927', component.options)
    }
    module.hot.accept("./GraphPanel.vue?vue&type=template&id=24e01927&scoped=true&lang=html&", function () {
      api.rerender('24e01927', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statistics/components/GraphPanel.vue"
export default component.exports